import React from 'react';
import DataTable from '~/components/datatable';
import { ListContainer } from '~/views/events/accredit-approval/styles';

export const TabPress = ({ pressList, columns, onRowClicked }) => {
  return (
    <ListContainer>
      <DataTable
        data={{ rows: pressList }}
        columns={columns}
        noPagination={true}
        emptyText="Nenhuma imprensa credenciada"
        onRowClicked={onRowClicked}
        keyField="company.identify"
        />
    </ListContainer>
  )
};